/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Processing_Notice_LabelInputs */

const en_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI processing disclosure`)
};

const de_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis zur KI-Verarbeitung`)
};

const fr_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis de traitement par l'IA`)
};

const es_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de procesamiento con IA`)
};

const it_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sul trattamento con IA`)
};

const nl_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennisgeving over AI-verwerking`)
};

const pl_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacja o przetwarzaniu przez AI`)
};

const fi_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitus AI-kasittelysta`)
};

const da_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oplysning om AI-behandling`)
};

const sv_ai_processing_notice_label = /** @type {(inputs: Ai_Processing_Notice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelande om AI-behandling`)
};

/**
* | output |
* | --- |
* | "AI processing disclosure" |
*
* @param {Ai_Processing_Notice_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ai_processing_notice_label = /** @type {((inputs?: Ai_Processing_Notice_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Processing_Notice_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_processing_notice_label(inputs)
	if (locale === "fr") return fr_ai_processing_notice_label(inputs)
	if (locale === "es") return es_ai_processing_notice_label(inputs)
	if (locale === "it") return it_ai_processing_notice_label(inputs)
	if (locale === "nl") return nl_ai_processing_notice_label(inputs)
	if (locale === "pl") return pl_ai_processing_notice_label(inputs)
	if (locale === "fi") return fi_ai_processing_notice_label(inputs)
	if (locale === "da") return da_ai_processing_notice_label(inputs)
	if (locale === "sv") return sv_ai_processing_notice_label(inputs)
	return en_ai_processing_notice_label(inputs)
});